import React from 'react';
import PropTypes from 'prop-types';
import ExpandableSection from '../../expandableSection';
import { ActionButtons, formatIndianCurrency } from './sectionShared';

const ProjectUnitsSection = ({
  expanded,
  onToggle,
  onDownload,
  projectUnitsData,
  onEditUnit,
  onDeleteUnit,
  onMoreMenuItems,
  onMore,
  showMoreAction,
  canViewUnitAmount,
  canEditUnit,
  canDeleteUnit,
  isLoading,
}) => {
  const rows = Array.isArray(projectUnitsData?.rows) ? projectUnitsData.rows : [];
  const totalUnitValue = rows.reduce(
    (sum, row) => sum + (Number(row?.unitPriceValue) || 0),
    0,
  );
  const showActions = canEditUnit || canDeleteUnit;
  const columnCount = 7 + (canViewUnitAmount ? 1 : 0) + (showActions ? 1 : 0);

  return (
    <ExpandableSection
      title="Project units"
      expanded={expanded}
      onToggle={onToggle}
      onDownload={onDownload}
      onMoreMenuItems={onMoreMenuItems}
      onMore={onMore}
      showMoreAction={showMoreAction}
      isLoading={isLoading}
    >
      <div className="section-content resource-count-section project-units-section">
        <div className="resource-count-table-wrapper">
          <div className="resource-count-table-scroll">
            <table className="resource-count-data-table">
              <thead>
                <tr>
                  <th className="th-cell th-col-serial">#</th>
                  <th className="th-cell">Resource Category</th>
                  <th className="th-cell">Resource Skills</th>
                  <th className="th-cell">Qty</th>
                  {canViewUnitAmount ? <th className="th-cell">Unit Cost/M</th> : null}
                  <th className="th-cell">Start Date</th>
                  <th className="th-cell">End Date</th>
                  <th className="th-cell">Remarks</th>
                  {showActions ? (
                    <th className="th-cell th-actions th-col-actions">
                      <div className="th-content th-actions-content">
                        <span>Actions</span>
                      </div>
                    </th>
                  ) : null}
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? rows.map((row, index) => (
                  <tr key={row.id} className="tr-data">
                    <td className="td-cell td-col-serial">{index + 1}</td>
                    <td className="td-cell">{row.resourceCategory}</td>
                    <td className="td-cell">{row.skills}</td>
                    <td className="td-cell">{row.quantity}</td>
                    {canViewUnitAmount ? <td className="td-cell">{row.unitPrice}</td> : null}
                    <td className="td-cell">{row.startDate}</td>
                    <td className="td-cell">{row.endDate}</td>
                    <td className="td-cell">{row.remarks}</td>
                    {showActions ? (
                      <td className="td-cell td-actions td-col-actions">
                        <ActionButtons
                          onEdit={canEditUnit ? () => onEditUnit(row) : null}
                          onDelete={canDeleteUnit ? () => onDeleteUnit(row) : null}
                        />
                      </td>
                    ) : null}
                  </tr>
                )) : (
                  <tr className="tr-data tr-empty">
                    <td className="td-cell" colSpan={columnCount}>No project units found.</td>
                  </tr>
                )}
                {rows.length > 0 && canViewUnitAmount ? (
                  <tr className="tr-data total-row sticky-total-row">
                    <td className="td-cell td-col-serial" />
                    <td className="td-cell" />
                    <td className="td-cell" />
                    <td className="td-cell"><strong>Total Value</strong></td>
                    <td className="td-cell">
                      <strong>{formatIndianCurrency(totalUnitValue)}</strong>
                    </td>
                    <td className="td-cell" />
                    <td className="td-cell" />
                    <td className="td-cell" />
                    {showActions ? <td className="td-cell td-actions td-col-actions" /> : null}
                  </tr>
                ) : null}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ExpandableSection>
  );
};

ProjectUnitsSection.propTypes = {
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onDownload: PropTypes.func,
  projectUnitsData: PropTypes.shape({
    isApplicable: PropTypes.bool,
    rows: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      quantity: PropTypes.string,
      skills: PropTypes.string,
      resourceCategory: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      unitPrice: PropTypes.string,
      unitPriceValue: PropTypes.number,
      remarks: PropTypes.string,
    })),
  }).isRequired,
  onEditUnit: PropTypes.func,
  onDeleteUnit: PropTypes.func,
  onMoreMenuItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
  })),
  onMore: PropTypes.func,
  showMoreAction: PropTypes.bool,
  canViewUnitAmount: PropTypes.bool,
  canEditUnit: PropTypes.bool,
  canDeleteUnit: PropTypes.bool,
  isLoading: PropTypes.bool,
};

ProjectUnitsSection.defaultProps = {
  onDownload: () => {},
  onEditUnit: () => {},
  onDeleteUnit: () => {},
  onMoreMenuItems: [],
  onMore: () => {},
  showMoreAction: false,
  canViewUnitAmount: false,
  canEditUnit: false,
  canDeleteUnit: false,
  isLoading: false,
};

export default ProjectUnitsSection;
